import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthenticationService, unauthenticated } from '@datev/ngx-dcal';
import { AppStateService } from 'commons';
import { Observable, of } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class DownloadService {
  private apiUrl = 'api/amr/download-portal-api/v1/download';

  constructor(
    private readonly http: HttpClient,
    private readonly authService: AuthenticationService,
    private readonly appStateService: AppStateService,
  ) {}

  public getDownloadLink(downloadId: string): Observable<string> {
    return this.authService.isLoggedIn.asObservable().pipe(
      switchMap(isLoggedIn => {
        if (isLoggedIn) {
          return this.appStateService.activeBusinessPartner$.pipe(
            map(({ id }) => {
              let params = new HttpParams();
              params = params.append('gpnr', id ?? '');
              return `${this.apiUrl}/${downloadId}/secured-download-link?${params.toString()}`;
            }),
          );
        }

        return of(`${this.apiUrl}/${downloadId}/download-link`);
      }),
      switchMap(url =>
        this.http.get<{ url: string }>(url, {
          context: unauthenticated(),
        }),
      ),
      map(response => response.url),
      take(1),
    );
  }
}
